export const CHECK_PROBATION_PERIOD_LOAD = 'CHECK_PROBATION_PERIOD_LOAD'
export const CHECK_PROBATION_PERIOD_LOAD_PENDING = 'CHECK_PROBATION_PERIOD_LOAD_PENDING'
export const CHECK_PROBATION_PERIOD_LOAD_FULFILLED = 'CHECK_PROBATION_PERIOD_LOAD_FULFILLED'
export const CHECK_PROBATION_PERIOD_LOAD_REJECTED = 'CHECK_PROBATION_PERIOD_LOAD_REJECTED'
